// language=GraphQL
export const ALL_ACCOMMODATION_ASSIGNMENTS_QUERY = `query Query($withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {
  accommodationAssignments: travelAccommodationAssignments {
    id
    accommodation @include(if: $withAccommodation) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withAccommodationRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationRoomTypesGallery) {
          id
        }
      }
      availableAddons @include(if: $withAccommodationAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAccommodationAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withAccommodationGallery) {
        id
        images @include(if: $withAccommodationGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    roomTypes @include(if: $withRoomTypes) {
      id
      name
      description
      gallery @include(if: $withRoomTypesGallery) {
        id
        images @include(if: $withRoomTypesGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    useCustomRoomTypeSelection
    displayDetails
  }
}`

// language=GraphQL
export const SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY = `query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {
  accommodationAssignment: travelAccommodationAssignment(id: $id) {
    id
    accommodation @include(if: $withAccommodation) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withAccommodationRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationRoomTypesGallery) {
          id
        }
      }
      availableAddons @include(if: $withAccommodationAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAccommodationAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withAccommodationGallery) {
        id
        images @include(if: $withAccommodationGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    roomTypes @include(if: $withRoomTypes) {
      id
      name
      description
      gallery @include(if: $withRoomTypesGallery) {
        id
        images @include(if: $withRoomTypesGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    useCustomRoomTypeSelection
    displayDetails
  }
}`

// language=GraphQL
export const CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: CreateTravelAccommodationAssignmentInput, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {
    accommodationAssignment: createTravelAccommodationAssignment(input: $input) {
      id
      accommodation @include(if: $withAccommodation) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationRoomTypesGallery) {
            id
          }
        }
        availableAddons @include(if: $withAccommodationAvailableAddons) {
          id
          name
          description
          icon @include(if: $withAccommodationAvailableAddonsIcon) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        gallery @include(if: $withAccommodationGallery) {
          id
          images @include(if: $withAccommodationGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      roomTypes @include(if: $withRoomTypes) {
        id
        name
        description
        gallery @include(if: $withRoomTypesGallery) {
          id
          images @include(if: $withRoomTypesGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      useCustomRoomTypeSelection
      displayDetails
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: UpdateTravelAccommodationAssignmentInput, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {
    accommodationAssignment: updateTravelAccommodationAssignment(input: $input) {
      id
      accommodation @include(if: $withAccommodation) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationRoomTypesGallery) {
            id
          }
        }
        availableAddons @include(if: $withAccommodationAvailableAddons) {
          id
          name
          description
          icon @include(if: $withAccommodationAvailableAddonsIcon) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        gallery @include(if: $withAccommodationGallery) {
          id
          images @include(if: $withAccommodationGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      roomTypes @include(if: $withRoomTypes) {
        id
        name
        description
        gallery @include(if: $withRoomTypesGallery) {
          id
          images @include(if: $withRoomTypesGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      useCustomRoomTypeSelection
      displayDetails
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: DeleteTravelAccommodationAssignmentInput) {
    deleteTravelAccommodationAssignment(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: DeleteTravelAccommodationAssignmentInput) {
    forceDeleteTravelAccommodationAssignment(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: addTravelAccommodationAssignmentRoomTypesInput) {
    addTravelAccommodationAssignmentRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const REMOVE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: removeTravelAccommodationAssignmentRoomTypesInput) {
    removeTravelAccommodationAssignmentRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const CREATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: createTravelAccommodationAssignmentRoomTypesInput) {
    createTravelAccommodationAssignmentRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: deleteTravelAccommodationAssignmentRoomTypesInput) {
    deleteTravelAccommodationAssignmentRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelAccommodationAssignmentRoomTypesOrderInput) {
    updateTravelAccommodationAssignmentRoomTypesOrder(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const ACCOMMODATION_ASSIGNMENTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelAccommodationAssignmentDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
